import { apiInstance } from './client';

// 동료 평가지 생성
function postPaperData(data) {
  return apiInstance({
    url: '/v1/evaluation-papers',
    method: 'post',
    data,
  });
}

// 동료 평가지 전송
function sendPaperToEmail(id) {
  return apiInstance({
    url: `/v1/evaluation-papers/${id}/email`,
    method: 'post',
  });
}

// 동료 평가지 조회
function getPaperData() {
  return apiInstance({
    url: '/v1/evaluation-papers',
    method: 'get',
    headers: {
      'Content-Type': 'multipart/form-datas;',
    },
  });
}

// 동료 평가지 상세 조회
function getPaperDetailData(evaluationPaperId) {
  return apiInstance({
    url: `/v1/evaluation-papers/${evaluationPaperId}`,
    method: 'get',
  });
}

// 학생 평가지 조회
function getStudentEvaluation(evaluationPaperId, studentId) {
  return apiInstance({
    url: `/v1/evaluation-papers/${evaluationPaperId}/students/${studentId}/reviews`,
    method: 'get',
  });
}

// 학생 평가지 저장
function putStudentEvaluation(data, evaluationPaperId, studentId) {
  return apiInstance({
    url: `/v1/evaluation-papers/${evaluationPaperId}/students/${studentId}/reviews`,
    method: 'put',
    data,
  });
}

export {
  postPaperData,
  sendPaperToEmail,
  getPaperData,
  getPaperDetailData,
  getStudentEvaluation,
  putStudentEvaluation,
};
